import React from 'react';
import Image from 'next/image';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const QR_FLOW_BASE = 'https://qr-flow.eu';

const SHOWCASE_ITEMS = [
    {
        image: '/images/qr-flow/form-generator.webp',
        link: `${QR_FLOW_BASE}/form-generator/`,
        key: '2',
    },
    {
        image: '/images/qr-flow/survey-generator.webp',
        link: `${QR_FLOW_BASE}/survey-generator/`,
        key: '3',
    },
    {
        image: '/images/qr-flow/feature-qr-codes.webp',
        link: `${QR_FLOW_BASE}/features/qr-codes/`,
        key: '4',
    },
    {
        image: '/images/qr-flow/qr-code-api.webp',
        link: `${QR_FLOW_BASE}/qr-code-api/`,
        key: '5',
    },
];

const QrFlowShowcase = () => {
    const { t } = useTranslations();

    return (
        <section className="qr-flow-showcase" id="screenshots">
            <div className="container">
                <FadeInAnimation direction="up" delay={50}>
                    <div className="qr-flow-showcase__intro">
                        <span className="qr-flow-showcase__badge">{t('qrFlow_showcase_badge')}</span>
                        <h2>{t('qrFlow_showcase_title')}</h2>
                        <p>{t('qrFlow_showcase_subtitle')}</p>
                    </div>
                </FadeInAnimation>

                <div className="qr-flow-showcase__stack">
                    {SHOWCASE_ITEMS.map((item, index) => {
                        const reverse = index % 2 === 1;
                        return (
                            <div
                                key={item.key}
                                className={`qr-flow-showcase__row${reverse ? ' qr-flow-showcase__row--reverse' : ''}`}
                            >
                                <FadeInAnimation direction={reverse ? 'left' : 'right'} delay={80 + index * 40}>
                                    <div className="qr-flow-showcase__copy">
                                        <h3>{t(`qrFlow_showcase_item${item.key}_title`)}</h3>
                                        <p>{t(`qrFlow_showcase_item${item.key}_desc`)}</p>
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="qr-flow-showcase__link"
                                        >
                                            {t(`qrFlow_showcase_item${item.key}_link`)}
                                        </a>
                                    </div>
                                </FadeInAnimation>
                                <FadeInAnimation direction={reverse ? 'right' : 'left'} delay={100 + index * 40}>
                                    <figure className="qr-flow-showcase__figure">
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="qr-flow-showcase__image-link"
                                            aria-label={t(`qrFlow_showcase_item${item.key}_title`)}
                                        >
                                            <Image
                                                src={item.image}
                                                alt={t(`qrFlow_showcase_item${item.key}_imageAlt`)}
                                                width={1440}
                                                height={900}
                                                className="qr-flow-showcase__image"
                                                sizes="(max-width: 992px) 100vw, 540px"
                                            />
                                        </a>
                                        <figcaption>{t(`qrFlow_showcase_item${item.key}_caption`)}</figcaption>
                                    </figure>
                                </FadeInAnimation>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default QrFlowShowcase;
